import { render, staticRenderFns } from "./LunchListAggregateCell.vue?vue&type=template&id=3816a2a1&"
import script from "./LunchListAggregateCell.vue?vue&type=script&lang=js&"
export * from "./LunchListAggregateCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports